<template>
  <div class="grid gap-6">
    <CartItem v-for="item of items" :key="item.ticket_id" :item />
    <div v-if="reverseChargeApplied" class="text-muted-foreground text-sm">
      * {{ $t("Due to local tax regulations the ticket(s) will be invoiced without VAT") }}
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

import CartItem from "./CartItem.vue";

import { useCartStore } from "@/store/cart.ts";

const cartStore = useCartStore();
const items = computed(() => cartStore.items);
const reverseChargeApplied = computed(
  () => cartStore.payDetails?.tickets?.some((ticket) => ticket.reverse_charge_applied) ?? false
);
</script>
